import { TextField } from '@mui/material';

interface ResponseModeFieldProps {
  value: string;
  setValue: (value: string) => void;
}

function ResponseModeField({
  value,
  setValue,
}: ResponseModeFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      label='Response Mode'
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default ResponseModeField;

